import React from 'react'

const BugBusters = () => {
    return (
        <>
            <h1>
                Bug Busters
            </h1>

        </>
    )
}

export default BugBusters
